module.exports = [{"type":"title","text":"2024-04-25"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Change perpetual contract: 'Contract Information' api supports querying by a symbol."},{"type":"html","text":"change perpetual contract: allFillOrders interface, when the symbol field is not provided, it will return the historical transaction information of all pairs."},{"type":"html","text":"Change perpetual contract: The query position api has a new Return Margin field."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-04-25.json
// module id = 0uHt
// module chunks = 3